import Box from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';

import { colors, devices } from 'styles';

export const PageWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCustomerCase',
})<{
  isCustomerCase: boolean;
}>`
  display: flex;
  flex-direction: ${(prop) => (prop.isCustomerCase ? 'column-reverse' : 'column')};
  width: 100%;
  justify-content: inherit;

  @media (${devices.lg}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCustomerCase',
})<{
  isCustomerCase: boolean;
}>`
  max-width: 100%;
  margin-right: 0;
  margin-bottom: ${(props) => (props.isCustomerCase ? '0px' : '80px')};

  @media (${devices.lg}) {
    max-width: 560px;
    margin-right: 80px;
    margin-bottom: 0;
  }
`;

export const DefaultImageWrapper = styled(Box)`
  max-width: 100%;
  background-color: ${colors.mainDark};
  border-radius: 16px;
  overflow: hidden;
  height: 100%;

  img {
    width: 100%;
    display: block;
    max-width: 100%;
    height: 100%;
  }
`;

export const CustomerCaseImageWrapper = styled(Box)`
  max-width: 100%;
  border-radius: 16px;
  overflow: hidden;
  height: 100%;
  width: 100%;

  img {
    height: 100%;
    width: 100%;
    display: block;
    object-fit: cover;
    transition: transform 0.4s linear;

    :hover {
      transform: scale(1.2);
    }
  }
`;
